module.exports = __webpack_public_path__ + "media/Radiohead - Bulletproof...I wish i was.dce490a3.mp3";